<template>
  <div class="user" ref="player">
    <div class="video"></div>
    <div class="name">{{user.role}}：{{user.name}}</div>
  </div>
</template>

<script>
  import { User } from '../models/user';

  export default {
    name: 'user',
    props: {
      user: User
    },
    mounted() {
      let userId = sessionStorage.getItem('phone');
      this.user.tracks.forEach(t => {
        if (t.info.kind === 'audio' && t.userId === userId) {
          return;
        }
        t.play(this.$refs.player);
        let videoElement = this.$refs.player.querySelector('video');
        if (videoElement) {
          videoElement.style.objectFit = 'cover';
          videoElement.style.transform = 'rotateY(180deg)';
        }
      });
    }
  };
</script>

<style scoped lang="scss">
  .user {
    width: 50vw;
    height: 37.5vw;
    background-color: #262931;
    box-sizing: border-box;
    overflow: hidden;
    position: relative;
    z-index: 98;

    .name {
      height: 4.5vw;
      line-height: 4.5vw;
      background: #000;
      text-align: center;
      position: absolute;
      left: 0;
      bottom: -1px;
      right: 0;
      color: #fff;
      z-index: 99;
    }
  }

</style>
